module.exports = __webpack_public_path__ + "img/signin_icon__inputbox_accout_normal.68c23576.svg";